// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import { NormalControl, NormalControlT } from "./normal-control";
import { ValuedControl, ValuedControlT } from "./valued-control";

export enum ControlVariant {
  NONE = 0,
  NormalControl = 1,
  ValuedControl = 2,
}

export function unionToControlVariant(
  type: ControlVariant,
  accessor: (obj: NormalControl | ValuedControl) => NormalControl | ValuedControl | null,
): NormalControl | ValuedControl | null {
  switch (ControlVariant[type]) {
    case "NONE":
      return null;
    case "NormalControl":
      return accessor(new NormalControl())! as NormalControl;
    case "ValuedControl":
      return accessor(new ValuedControl())! as ValuedControl;
    default:
      return null;
  }
}

export function unionListToControlVariant(
  type: ControlVariant,
  accessor: (
    index: number,
    obj: NormalControl | ValuedControl,
  ) => NormalControl | ValuedControl | null,
  index: number,
): NormalControl | ValuedControl | null {
  switch (ControlVariant[type]) {
    case "NONE":
      return null;
    case "NormalControl":
      return accessor(index, new NormalControl())! as NormalControl;
    case "ValuedControl":
      return accessor(index, new ValuedControl())! as ValuedControl;
    default:
      return null;
  }
}

export type ControlVariantT =
  | { type: "NONE"; value: null }
  | { type: "NormalControl"; value: NormalControlT }
  | { type: "ValuedControl"; value: ValuedControlT };
